export const titles = [
    { value: 'Mr', label: 'Mr' },
    { value: 'Ms', label: 'Ms' },
    { value: 'Mrs', label: 'Mrs' },
    { value: 'Miss', label: 'Miss' },
    { value: 'Dr', label: 'Doctor' },
    { value: 'Prof', label: 'Professor' },
    { value: 'Sir', label: 'Sir' },
    { value: 'Lord', label: 'Lord' },
    { value: 'Lady', label: 'Lady' },
    { value: 'Baron', label: 'Baron' },
    { value: 'Baroness', label: 'Baroness' },
    { value: 'Rev', label: 'Reverend' }
];
